import React, { useState } from 'react';
import './About.css';
import { MdDescription, MdEmail, MdPhone, MdSchool, MdDirectionsCar } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import useAutoTranslate from '../../hooks/useAutoTranslate';
import { pub } from '../../utils/Publiccurl';
import fr from './langue/fr.json';
import en from './langue/en.json';

function About() {
  const [phoneVisible, setPhoneVisible] = useState(false);
  const t = useAutoTranslate({ fr, en });

  return (
    <section className="about bg-dark-section" id="moi">
      <div className="section-container">
        <div className="text-center">
          <h2 className="section-heading">{t('titre_section')}</h2>
        </div>
        <div className="about__content">
          <div className="about__icons">
            <InfoItem icon={MdSchool}>{t('label_etudiant')}</InfoItem>
            <InfoItem icon={MdDirectionsCar}>{t('label_permis')}</InfoItem>
            {/* 
              href={pub(t('cv_path'))}
              target="_blank"
              rel="noreferrer"
              className="about__icon-item about__icon-item--cv"
            >
              <MdDescription />
              <span>{t('label_cv')}</span>
            </a> */}
          </div>
          <div className="about__text">
            <p>
              {t('para1')} <strong>JUNIA ISEN</strong>
              <br />
              {t('para1_suite')}
            </p>
            <p>{t('para2')}</p>
          </div>
          <div className="about__contact">
            <h4>{t('titre_contact')}</h4>
            <div className="about__contact-links">
              <ContactLink
                href="https://www.linkedin.com/in/baptiste-lemattre"
                icon={FaLinkedin}
                label="LinkedIn"
              />
              <button
                type="button"
                className="contact-btn"
                onClick={() => setPhoneVisible(!phoneVisible)}
              >
                <MdPhone />
                <span>{phoneVisible ? '07 67 49 50 69' : t('label_telephone')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoItem({ icon: Icon, children }) {
  return (
    <div className="about__icon-item">
      <Icon />
      <span>{children}</span>
    </div>
  );
}

function ContactLink({ href, icon: Icon, label }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" className="contact-btn">
      <Icon />
      <span>{label}</span>
    </a>
  );
}

export default About;